import { useMsal } from "@azure/msal-react";
import { BaseApiService } from "./baseApiService";

export const useAccessRequestService = () => {
    const { instance } = useMsal();
    return new AccessRequestService(instance);
};

class AccessRequestService extends BaseApiService {

    async createRequest({ newAccessRequests }) {
        const url = 'AccessRequest';
        return await this.post(url, newAccessRequests);
    }
}